import { useState } from "react";
import {
  Menu,
  MenuItem,
  Button,
  Checkbox,
  ListItemText,
  TextField,
  Box
} from "@mui/material";
import { getString } from "../../lang";

const SearchUserFilter = ({
  options = [],
  label = "Select",
  value,
  onChange,
}) => {
    // console.log("SearchUserFilter rendered with options:", options);
    const [anchorEl, setAnchorEl] = useState(null);
    const [search, setSearch] = useState("");

    const [selectedUsers, setSelectedUsers] = useState([]);

    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSearch(""); // reset search when closing
    };

    const handleSelect = (option) => {
        let newValue = Array.isArray(value) ? [...value] : [];;

        const exists = newValue.some((item) => item.value === option.value);

        if(exists) {
            newValue = newValue.filter((item) => item.value !== option.value);
        }else{
            newValue.push(option);
        }
        
        setSelectedUsers(newValue);
        onChange(newValue);
    }

    const filteredOptions = options.filter((opt) =>
        opt.label.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <Button
                variant="text"
                onClick={ handleOpen }
                sx={{ textTransform: "none", fontWeight: 500 }}>
                { label }
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} slotProps={{ paper: { sx: { maxHeight: 300, width: 260 }}
            }}>
                <Box sx={{ p: 1 }}>
                    <TextField
                        size="small"
                        placeholder={getString('search')}
                        fullWidth
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => e.stopPropagation()}
                    />
                </Box>

                {filteredOptions.map((option) => (
                    <MenuItem
                        key={option.value}
                    >
                        <Checkbox
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSelect(option);
                            }}
                            checked={Array.isArray(value) && value.some(
                                (item) => item.value === option.value
                            )}
                        />

                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}

                {/* No results */}
                {filteredOptions.length === 0 && (
                    <MenuItem disabled>No results</MenuItem>
                )}

            </Menu>
        </>
    )
}

export default SearchUserFilter;